import { render, staticRenderFns } from "./ServicesCards.vue?vue&type=template&id=be09403a"
import script from "./ServicesCards.vue?vue&type=script&lang=js"
export * from "./ServicesCards.vue?vue&type=script&lang=js"
import style0 from "./ServicesCards.vue?vue&type=style&index=0&id=be09403a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports